import ThemeTableCard from './container';

export default ThemeTableCard;



// WEBPACK FOOTER //
// ./src/components/Cards/ThemeTableCard/index.js